module.exports = __webpack_public_path__ + "static/media/8OLA16.debafe61.jpg";